import { Component, input } from '@angular/core';
import { ParkourIconComponent, TParkourIconName } from '@parkour/ui';

@Component({
  selector: 'parkour-profiel-details-card',
  standalone: true,
  imports: [ParkourIconComponent],
  templateUrl: './profiel-details-card.component.html',
})
export class ProfielDetailsCardComponent {
  public readonly title = input.required<string>();
  public readonly backgroundColor = input.required<'bg-n-300' | 'bg-n-200'>();
  public readonly icon = input.required<TParkourIconName>();
}
